import Router from 'vue-router';
import User from '@/utils/user';

const user = new User();

const routes = [
  {
    path: '/403',
    name: '403',
    component: () => import('./views/403.vue'),
    meta: {
      title: 'Доступ запрещён',
      layout: 'ui-design',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./views/404.vue'),
    beforeEnter: (to, from, next) => {
      const isInitialNotFound = from === Router.START_LOCATION
        && ['/404', '/404/'].includes(window.location.pathname);
      const navigation = isInitialNotFound
        ? window.performance?.getEntriesByType?.('navigation')?.[0]
        : null;

      if (navigation?.type === 'reload') {
        next({ name: 'main', replace: true });
        return;
      }
      next();
    },
    meta: {
      title: 'Страница не найдена',
      layout: 'ui-design',
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import('./views/500.vue'),
    meta: {
      title: 'Ошибка сервера',
      layout: 'ui-design',
    },
  },

];

export default routes.map((route) => ({
  ...route,
  meta: {
    ...route.meta,
    ...user?.isOrganization ? {
      layout: 'ui-design',
    } : {},
  },
}));
